import script from "./holeNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./holeNavigation.vue?vue&type=script&setup=true&lang=js"

import "./holeNavigation.vue?vue&type=style&index=0&id=0e78f1fd&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e78f1fd"]])

export default __exports__